import * as dressageActions from './actions';
import {ActionType, getType} from 'typesafe-actions';
import {DressageState, JsonDressageLine, JsonDressageProtocol, JsonDressageStep} from './types';
import DateUtils from "../../utils/Date.utils";
import DressageProtocol from "../../domain/DressageProtocol";
import DressageSteps from "../../domain/DressageSteps";
import DressageStep from "../../domain/DressageStep";
import DressageLines from "../../domain/DressageLines";
import DressageLine from "../../domain/DressageLine";

const defaultState: DressageState = {
  dressageProtocol: undefined,
  lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
};

export default (state = defaultState, action: ActionType<typeof dressageActions>): DressageState => {
  switch (action.type) {
    case getType(dressageActions.fetchDressageProtocol.success):
      let dressageProtocol: JsonDressageProtocol = action.payload;
      return {
        ...state,
        lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp(),
        dressageProtocol: toDressageProtocol(dressageProtocol)
      };
    default:
      return state;
  }
}

function toDressageProtocol(json: JsonDressageProtocol): DressageProtocol {
  try {
    return new DressageProtocol(
      json.id,
      json.series,
      json.protocolNumber,
      json.period,
      json.remarks,
      json.arenaDimensions,
      new DressageSteps(json.dressageProtocolSteps.map(s => toDressageStep(s)))
    );
  } catch (e) {
    console.error(e);
    throw new Error(e);
  }
}

function toDressageStep(s: JsonDressageStep) {
  return new DressageStep(
    s.index,
    s.imageUrl,
    new DressageLines(s.dressageLines.map(l => toDressageLine(l)))
  )
}

function toDressageLine(l: JsonDressageLine) {
  return new DressageLine(l.direction, l.command);
}


